module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f79950112152d30a89c54961386d3333.png";